import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Select } from "antd";
import Button from "../../Layout/DesignSystem/Button/Button";
// import { Title } from "../../Utils/UI/Text";
import { getProjectsSelector } from "../Infrastructure/Projects.reducer";
import { getProjects, getProject } from "../Application/Projects.business";
import "./Projects.css";

const { Option } = Select;

export default function Searcher({ onProjectSelect }) {
  const records = useSelector(getProjectsSelector);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const onFinish = async ({ id }) => {
    getProject(selectedProjectId);
    if (onProjectSelect) {
      onProjectSelect(selectedProjectId);
    } else {
      navigate(`/projects/${selectedProjectId}`);
    }
  };

  const onReset = () => {
    form.resetFields();
    setSelectedProjectId(null);
    if (onProjectSelect) {
      onProjectSelect(null);
    }
  };
  
  const handleSelectChange = (value) => {
    console.log("Proyecto seleccionado en dropdown:", value);
    setSelectedProjectId(value);
    if (onProjectSelect) {
      onProjectSelect(value);
    }
  };

  function onSearch(val) {
    const params = {
      filter: { access_level: ["partner"] },
      page: 0,
      limit: 10,
      field_sort: "date",
      sort: "descending",
    };

    if (val) {
      params.q = val;
    }

    getProjects(params);
  }

  return (
    <>
      {/* <Title children="Proyectos" /> */}

      <Form
        layout="horizontal"
        form={form}
        onFinish={onFinish}
        onReset={onReset}
      >
        <div className="grid-searcher-project">
          <Select
            className="searcher-project-select"
            name="id"
            clearIcon
            showSearch
            onSearch={onSearch}
            placeholder="Selecciona un proyecto"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleSelectChange}
            value={selectedProjectId}
            allowClear
          >
            {records?.map((record) => (
              <Option value={record.id} key={record.id}>
                {`${record.projectName}`}
              </Option>
            ))}
          </Select>

          <Button htmlType="submit" text={"Seleccionar"} />
        </div>
      </Form>
    </>
  );
}